export default "__VITE_ASSET__C3mDl_Zi__"